'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');
var constants = require('./constants-d8339ee1.js');
var perfill = require('./perfill-505e8086.js');

var _require = constants.constants,
  PERFORMANCE_MARK_HYDRATE = _require.PERFORMANCE_MARK_HYDRATE,
  PERFORMANCE_MEASURE_NAME = _require.PERFORMANCE_MEASURE_NAME,
  PERFORMANCE_MEASURE_COMPLETE = _require.PERFORMANCE_MEASURE_COMPLETE;
var _require2 = perfill.perfill,
  perfillIfApplies = _require2.perfillIfApplies;
function hasPerformanceApi() {
  return typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.measure === 'function';
}
function markIfApplies(type) {
  if (!hasPerformanceApi()) {
    return;
  }
  performance.mark(type);
}
function measureIfApplies() {
  if (!hasPerformanceApi()) {
    return;
  }
  performance.mark(PERFORMANCE_MEASURE_COMPLETE);
  performance.measure(PERFORMANCE_MEASURE_NAME, PERFORMANCE_MARK_HYDRATE, PERFORMANCE_MEASURE_COMPLETE);
  var _performance$getEntri = performance.getEntriesByName(PERFORMANCE_MEASURE_NAME),
    entry = _performance$getEntri[0];
  perfillIfApplies(entry);
}
var performance_1 = {
  markIfApplies: markIfApplies,
  measureIfApplies: measureIfApplies
};
var performance$1 = _commonjsHelpers.getDefaultExportFromCjs(performance_1);

exports.performance = performance$1;
exports.performance_1 = performance_1;
